// Content Variables
export var CONTENT_VARIABLES = {
  variables: {
    year: new Date().getFullYear().toString()
  }
};

// Content Variables to be used in widgets
export var WIDGET_CONTENT_VARIABLES = ['radius', 'address'];